import {
  destroySponsorDiscussions,
  partialUpdateSponsorDiscussions,
  SponsorBoothDiscussionGroups,
  createSponsorDiscussions,
  listDiscussionGroups,
  PaginatedDiscussionGroupList,
  createDiscussionGroup,
  DiscussionGroupRequest,
  deleteDiscussionGroup,
  partiallyUpdateDiscussionGroup,
  updateRanksDiscussionGroups
} from '@goldcast/api/backend';

import { Payload, updateRoomPayload, Room } from './types';
import { transformServerRooms } from './utils';

const actions = {
  async loadRooms({ dispatch, commit }, eventId: string) {
    commit('setIsLoading', true);

    listDiscussionGroups({
      queryParams: {
        event: eventId
      }
    })
      .then((roomsData: PaginatedDiscussionGroupList) => {
        const rooms = transformServerRooms(roomsData);
        commit('setRooms', rooms);
      })
      .catch(() => {
        dispatch(
          'studioToast/triggerToast',
          { msg: 'Error Loading Rooms, Please Try Again', mode: 'error' },
          { root: true }
        );
      })
      .finally(() => {
        commit('setIsLoading', false);
      });
  },

  async createRoom({ rootState }, payload: Payload) {
    const eventId: string = rootState.studioEventList.currentEventId;
    const body = { ...payload, event: eventId };
    return new Promise((resolve, reject) => {
      createDiscussionGroup({
        body
      })
        .then((room: DiscussionGroupRequest) => {
          resolve(room);
        })
        .catch(reject);
    });
  },

  async updateRoom({ commit }, payload: updateRoomPayload) {
    return new Promise((resolve, reject) => {
      partiallyUpdateDiscussionGroup({ id: payload.id, body: payload.body })
        .then(response => {
          commit('updateRoom', response);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  async deleteRoom({ commit }, roomId: string) {
    return new Promise((resolve, reject) => {
      deleteDiscussionGroup({
        id: roomId
      })
        .then(() => {
          commit('deleteRoom', roomId);
          resolve(roomId);
        })
        .catch(reject);
    });
  },

  reorderRooms({ commit, rootGetters }, rooms: Room[]) {
    const newData = {
      object_list: rooms.map((room, index) => {
        return {
          pk: room.id,
          rank: index
        };
      })
    };
    const prevRooms = rootGetters['rooms/getRooms'];
    commit('reorderRooms', rooms);
    return new Promise((resolve, reject) => {
      updateRanksDiscussionGroups({
        body: newData
      })
        .then(() => {
          resolve('success');
        })
        .catch((error: any) => {
          commit('reorderRooms', prevRooms);
          reject(error);
        });
    });
  },

  async createSponsorBoothRoom({ rootState }, payload: Payload) {
    const eventId: string = rootState.studioEventList.currentEventId;
    const body = { ...payload, event: eventId };

    return new Promise((resolve, reject) => {
      createSponsorDiscussions({ body })
        .then((room: SponsorBoothDiscussionGroups) => {
          resolve(room);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  async deleteSponsorBoothRoom({ commit }, roomId: string) {
    return new Promise((resolve, reject) => {
      destroySponsorDiscussions({ id: roomId })
        .then(() => {
          commit('deleteRoom', roomId);
          resolve(roomId);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  async updateSponsorBoothRoom({ commit }, payload: updateRoomPayload) {
    return new Promise((resolve, reject) => {
      partialUpdateSponsorDiscussions({ id: payload.id, body: payload.body })
        .then((response: SponsorBoothDiscussionGroups) => {
          commit('updateRoom', response);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};

export default actions;
